import { encryptLoginPassword } from '@tiger/api-signature';
import Debug from '@tiger/debug';
import { Button, Form } from 'antd';
import React from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import ConfirmPassword from 'components/forms/Password';
import Toast from 'components/Toast';
import API from 'utils/API';
import http from 'utils/http';

interface LocationState {
    verify_token: string;
    grant_type: string;
    email: string;
    phone: string;
    tel_code: string;
}

const PasswordVerify: React.FC = () => {
    const $formutil = useForm();
    const location = useLocation();
    const navigate = useNavigate();
    const { verify_token, grant_type, email, phone, tel_code } = (location.state as LocationState) || {};

    const submit = async () => {
        const { $params, $invalid, $batchState, $getFirstError } = $formutil;

        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            const params: any = {
                ...$params,
                verify_token,
                grant_type,
                username: grant_type === 'phone' ? phone : email,
                tel_code,
                pwd_api_ver: 'v2',
                login_password: encryptLoginPassword($params.login_password)
            };

            delete params.confirm_password;
            Toast.loading(true);

            try {
                await http.post(API.OAUTH.resetLoginPassword(), params);

                Toast.show(__('Reset Success'));
                navigate('../success');
            } catch (error) {
                Toast.show(error);

                // code: 11084 超时
                if (error.error_code === 11084) {
                    navigate('../verify');
                }
            }

            Toast.loading(false);
        }
    };

    if (!verify_token) {
        return <Navigate to="../verify" />;
    }

    return (
        <Card form>
            <Form layout="vertical" colon={false} onFinish={submit}>
                <h3>{__('Please set a new password.')}</h3>
                <ConfirmPassword />
                <CardButtonWrap className="mt-5">
                    <Button htmlType="submit" block type="primary" size="large">
                        {__('Submit')}
                    </Button>
                </CardButtonWrap>
                <Debug data={$formutil.$params} />
            </Form>
        </Card>
    );
};

export default withForm(PasswordVerify);
